<!-- <h1 mat-dialog-title>{{'ALERT_DIALOG.TITLE' | translate}}</h1> -->
<div mat-dialog-content>
  <p [innerHtml]="message"></p>
</div>
<div mat-dialog-actions align="end">
    <button 
        mat-raised-button color="primary"  class="btn-return"
        cdkFocusInitial
        [matDialogClose]="true">
        {{'ALERT_DIALOG.ACCEPT' | translate}}
    </button>
</div>
